import React from "react";
import useTrusteeBondRetrieve from "./hooks/useTrusteeBondRetrieve";
import { BOND_RETRIEVE_PAGE_SECTIONS } from "./bondRetrievePageSections";
import { BondRetrievalShell } from "./components/bondRetrieval/BondRetrievalShell";
import {
  formatCorrectionFieldLabel,
  formatCorrectionFromTo,
} from "./components/TrusteeBondRetrieveShared";

const VermostTrusteeBondRetrieveForm = () => {
  const hookState = useTrusteeBondRetrieve();
  const sectionConfig = BOND_RETRIEVE_PAGE_SECTIONS.trustee;
  const pageCtx = {
    globalState: hookState.globalState,
    updateGlobalState: hookState.updateGlobalState,
    role: hookState.role,
    disabled: hookState.disabled,
    data: hookState.data,
    userdetails: hookState.userdetails,
    bond_id: hookState.bond_id,
    uploadToADLS: hookState.uploadToADLS,
  };

  return (
    <BondRetrievalShell
      kind="trustee"
      sectionConfig={sectionConfig}
      pageCtx={pageCtx}
      onSubmitDataCorrection={hookState.handleSubmitDataCorrection}
      formatCorrectionFieldLabel={formatCorrectionFieldLabel}
      formatCorrectionFromTo={formatCorrectionFromTo}
      {...hookState}
    />
  );
};

export default VermostTrusteeBondRetrieveForm;
